import { render, staticRenderFns } from "./search-header.vue?vue&type=template&id=90f5e44a&"
import script from "./search-header.vue?vue&type=script&lang=ts&"
export * from "./search-header.vue?vue&type=script&lang=ts&"
import style0 from "./search-header.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports